import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta09 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-09/utils-consultaSeguimentoPergunta09'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta09 } from './converter-HistoricoMchatPergunta09'

interface HistoricoMChatRfPergunta03Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta09 = (props: Readonly<HistoricoMChatRfPergunta03Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta09(aplicacoes)
  if (converted == null) return null

  const { header, exemplosTrazPraVoce, perguntaSoParaMostrar, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta09(model)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='9'
        title='“(Perguntar usando o nome da criança) traz coisas para mostrar para você ou as segura para que você as veja? Não para conseguir ajuda, mas apenas para compartilhar?”'
        value={header.stPassou}
        pergunta='“Seu filho às vezes traz para você...”'
      />
      <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={exemplosTrazPraVoce} />
      {perguntaSoParaMostrar && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[perguntaSoParaMostrar]} />}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
